import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  CanLoad,
  Route,
  Router,
  RouterStateSnapshot,
  UrlSegment,
  UrlTree,
} from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PaymentStatus, selectSubscription } from 'subscription-store';

@Injectable({
  providedIn: 'root',
})
export class SubscriptionGuard
  implements CanActivate, CanActivateChild, CanLoad
{
  constructor(private router: Router, private store: Store) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return true;
  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.store.select(selectSubscription).pipe(
      map((selectSubscription) => {
        if (state.url === '/' || state.url.includes('plano-pagamento')) {
          return true;
        }
        const isSubscriptionOk =
          selectSubscription?.paymentStatus === PaymentStatus.PAID;
        if (isSubscriptionOk) {
          return true;
        } else {
          return false;
        }
      })
    );
  }

  canLoad(
    route: Route,
    segments: UrlSegment[]
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.router.parseUrl('/app/home/plano-pagamento');
  }
}
